var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.tiendas),function(tienda,i){return _c('v-col',{key:("tienda_" + i),attrs:{"cols":"4"}},[_c('TiendaCard',{attrs:{"tienda":tienda}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }